// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 8/28/2023 5:40:01 PM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { ApplicationTypeEnum } from '../schema/Schema';
import { CompanyStatusTypeEnum } from '../schema/Schema';
import { CultureTypeEnum } from '../schema/Schema';
import { TimeZoneTypeEnum } from '../schema/Schema';
import { SecurityRoleTypeEnum } from '../schema/Schema';

export enum LandingPageTypeEnum {
  notDefined = 0,
  payroll = 1,
  people = 2,
  reports = 3,
  general = 4,
}

export enum WagepointMenuTypeEnum {
  companyDetails = 16,
  payrollSettings = 22,
  people = 25,
  taxSettings = 28,
  payroll = 31,
}

export enum WagepointCompanySettingEnum {
  general = 61,
  userAccounts = 64,
  associatedCompany = 82,
  notifications = 150,
  accountingBookkeepingFirm = 85,
  closeAccount = 67,
}

export enum EmployeeMenuTypeEnum {
  overview = 189,
  personal = 101,
  jobPay = 113,
  reports = 116,
}

export enum SmallBusinessMenuEnum {
  payroll = 31,
  reports = 79,
  people = 25,
  company = 16,
  addOns = 1,
  settings = 2,
}

export enum PayrollMenuEnum {
  overview = 192,
  paystubMemo = 196,
  paygroup = 199,
  holidayPayCalculator = 202,
  negativeAdjustment = 193,
  recordOfEmployment = 205,
}

export enum PeopleMenuEnum {
  peopleList = 1,
  department = 2,
  jobTitle = 3,
}

export enum CompanyMenuEnum {
  about = 16,
  banking = 19,
  accountVerification = 153,
}

export enum CompanySettingsMenuEnum {
  rolesPermissions = 180,
  administrators = 64,
  accountingBookkeepingFirm = 85,
  notifications = 150,
  associatedCompanies = 82,
  billing = 67,
}

export enum PayrollSettingsMenuEnum {
  generalSettings = 156,
  income = 159,
  deduction = 162,
  benefit = 165,
  statutoryHoliday = 168,
  workersCompensation = 171,
}

export enum TaxSettingsMenuEnum {
  sourceDeduction = 174,
  employerTax = 177,
}

export enum ReportsMenuEnum {
  register = 34,
  payrollTax = 186,
  payStubs = 49,
  earn = 40,
  benefits = 43,
  deductions = 46,
  wc = 37,
  ytd = 52,
  journal = 58,
  deposit = 55,
  invoice = 73,
  yearEnd = 94,
  AnnualReport = 430,
}

export enum CompanyViewTypeEnum {
  notDefined = 0,
  customer = 1,
  partner = 2,
}

export enum BannerTypeEnum {
  notDefined = 0,
  nsfLock = 1,
  trialExpiring = 2,
}

export interface GetConfigurationRequestInterface {
  applicationType: ApplicationTypeEnum;
  companyViewType?: CompanyViewTypeEnum;
}

export interface GetConfigurationResponseInterface {
  hasAssociatedCompanys: boolean;
  logoId?: number;
  useLogoAsFavicon?: boolean;
  companyStatusType: CompanyStatusTypeEnum;
  isPartnerFirm: boolean;
  menuList: Array<MenuInterface>;
  userDetail: UserDetailInterface;
  wagepointCompanySettingsList: Array<WagepointCompanySettingsInterface>;
  bannerList: Array<BannerInterface>;
  validationResults: ValidationResultsInterface;
}

export interface MenuInterface {
  id: number;
  name: string;
  icon: string;
  tooltip: string;
  customClass: string;
  description: string;
  url: string;
  floatDirection: string;
  key: string;
  isVisible: boolean;
  isDisabled: boolean;
  isViewOnly: boolean;
  menuItemList: Array<MenuInterface>;
  subMenuList: Array<MenuInterface>;
}

export interface UserDetailInterface {
  firstName: string;
  lastName: string;
  cultureType: CultureTypeEnum;
  tenantId: number;
  companyName: string;
  dontShowMeFlags: number;
  timeZoneType: TimeZoneTypeEnum;
  personId: number;
  companyCode: string;
  avatarDocumentId?: number;
  isEmployee: boolean;
  userId?: number;
  isAdmin: boolean;
  securityRoleType: SecurityRoleTypeEnum;
  companyType: number;
  accountOwnerName: string;
  isContractor: boolean;
  emailAddress: string;
  country: CountryInterface;
}

export interface CountryInterface {
  id: number;
  name: string;
}

export interface WagepointCompanySettingsInterface {
  companySettingType: WagepointCompanySettingEnum;
  isVisible: boolean;
  isDisabled: boolean;
}

export interface PermissionActionInterface {
  id: number;
  name: string;
  permissionActionParentId: number;
  permissionType: number;
  description: string;
}

export interface HomeRealmInterface {
  tenantId: number;
  companyId: number;
  companyName: string;
}

export interface KeepAliveRequestInterface {}

export interface KeepAliveResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface BannerInterface {
  bannerType: BannerTypeEnum;
  getConfigurationResponse: GetConfigurationResponseInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

import { Post } from '../../../httpClient';

export class UiConfigAccessService {
  getConfiguration(request: GetConfigurationRequestInterface): Promise<GetConfigurationResponseInterface> {
    return Post('/AppCoreUiConfigAccess/getConfiguration', request);
  }

  keepAlive(request: KeepAliveRequestInterface): Promise<KeepAliveResponseInterface> {
    return Post('/AppCoreUiConfigAccess/keepAlive', request);
  }
}

export default new UiConfigAccessService();
